import { Main } from "layouts";
import { PostsView } from "views";

function App() {
  return (
    <Main className="App">
      <PostsView />
    </Main>
  );
}

export default App;
